import { transition } from '@helpers/animation';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  background-color: ${brand.white};
  padding: ${fluid(8, 10)} 0;
  color: ${brand.black};
  overflow: hidden;
  position: relative;
`;
const ItemList = styled.div `
  --speed: 20s;
  --count: 5;
  --cardGap: ${fluid(32, 40)};

  display: flex;
  gap: var(--cardGap);

  @media ${until(Device.Tablet)} {
    &[data-scroll-active='true'] {
      animation: scrollingMobile var(--speed) linear infinite;
    }
  }

  @media ${`${from(Device.Tablet)} and ${until(Device.TabletLarge)}`} {
    &[data-scroll-active='true'] {
      animation: scrollingTablet var(--speed) linear infinite;
    }
  }

  @media ${`${from(Device.TabletLarge)} and ${until(Device.DesktopSmall)}`} {
    &[data-scroll-active-on='tablet-large'][data-scroll-active='true'] {
      animation: scrolling var(--speed) linear infinite;
    }
  }

  @media ${from(Device.DesktopSmall)} {
    justify-content: space-around;
  }

  &:hover {
    animation-play-state: paused;
  }

  @keyframes scrollingMobile {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(
        calc(var(--count) * (var(--cardGap) + calc(80% - var(--cardGap))) * -1)
      );
    }
  }

  @keyframes scrollingTablet {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(
        calc(var(--count) * (var(--cardGap) + calc(50% - var(--cardGap))) * -1)
      );
    }
  }

  @keyframes scrolling {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(
        calc(var(--count) * (var(--cardGap) + calc(33% - var(--cardGap))) * -1)
      );
    }
  }
`;
const Item = styled.div `
  --cardWidth: 80%;

  display: grid;
  align-items: center;
  color: currentColor;
  gap: 3px 12px;
  text-decoration: none;

  @media ${until(Device.DesktopSmall)} {
    flex: 0 0 calc(var(--cardWidth) - var(--cardGap));
    margin: 0 auto;
  }

  @media ${`${from(Device.Tablet)} and ${until(Device.TabletLarge)}`} {
    --cardWidth: 50%;
  }

  @media ${`${from(Device.TabletLarge)} and ${until(Device.DesktopSmall)}`} {
    --cardWidth: 33%;
  }

  a& {
    &:hover {
      ${() => Arrow} {
        transform: translateX(3px);
      }
    }
  }

  grid-template-columns: auto 1fr;
`;
const IconWrapper = styled.div `
  ${transition('transform, opacity')};
  grid-area: 1 / 1 / span 1 / span 1;
  transition-delay: calc(100ms * var(--i));

  [data-in-view='false'] & {
    opacity: 0;
    transform: translateY(20px);
  }

  @media ${until(Device.Tablet)} {
    width: 30px;
  }
`;
const Icon = styled.img `
  object-fit: contain;
  object-position: center;
`;
const Copy = styled.div `
  grid-area: 1 / 2 / span 1 / span 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;

  @media ${until(Device.Tablet)} {
    gap: 2px;
  }
`;
const Title = styled.h3 `
  ${transition('transform, opacity')};
  ${fonts.inter.extraBold};

  display: flex;
  align-items: center;
  font-size: ${fluid(14, 18)};
  line-height: ${fluid(20, 26)};
  text-transform: uppercase;
  transition-delay: calc(250ms * var(--i));

  [data-in-view='false'] & {
    opacity: 0;
    transform: translateY(20px);
  }

  @media ${from(Device.DesktopSmall)} {
    white-space: nowrap;
  }
`;
const Text = styled.p `
  ${transition('transform, opacity')};
  ${fonts.sofiaPro.regular};
  font-size: ${fluid(12, 14)};
  line-height: ${fluid(18, 24)};
  transition-delay: calc(300ms * var(--i));

  [data-in-view='false'] & {
    opacity: 0;
    transform: translateY(20px);
  }
`;
const Arrow = styled.span `
  transition: transform 0.2s ease-in-out;
  grid-area: 1 / 3 / span 2 / span 1;
  margin: 0 0 0 8px;
`;
const RatingImage = styled.img `
  display: inline-block;
  margin-left: 12px;
`;
const UspBannerStyles = {
    Arrow,
    Container,
    Copy,
    Icon,
    IconWrapper,
    Item,
    ItemList,
    RatingImage,
    Text,
    Title,
};
export default UspBannerStyles;
